__turbopack_context__.v({
  "active_item": "NavItems-module-scss-module__XnEgDq__active_item",
  "nav_item_btn": "NavItems-module-scss-module__XnEgDq__nav_item_btn",
  "nav_item_link": "NavItems-module-scss-module__XnEgDq__nav_item_link",
  "nav_items": "NavItems-module-scss-module__XnEgDq__nav_items",
});
